import {Html} from 'quickstart/components/content/Html'
import {Text} from 'quickstart/components/content/Text'
import {useMarkdown} from 'quickstart/hooks'
import type {ReactNode} from 'react'

export const useMarkdownMaybe = (x: ReactNode) => {
  const isMarkdown = typeof x === 'string'
  const html = useMarkdown(isMarkdown && x)
  return !isMarkdown ? (
    x && <Text>{x}</Text>
  ) : html?.trim() ? (
    <Html html={html} variant="raw" />
  ) : null
}
